var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('clientsView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }